import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteVisitPartAction } from '../../../../redux/actions/visitPartsActions';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';

const DeleteVisitPartModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit?.visit);
  const visitPart = useSelector((state) => state.visitParts?.visitPart);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteVisitPartAction(vin, id, visitPart.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення деталі візиту'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю деталь візиту?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteVisitPartModal;
